import React, { useState } from 'react'
import { reduxForm } from 'redux-form'
import * as actions from '../actions'
import { connect } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import HistoryIcon from '@material-ui/icons/History'
import ImportExportIcon from '@material-ui/icons/ImportExport'
// import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Dialog } from '@material-ui/core'
import DialogoComunicacionHistorial from '../components/DialogoComunicacionHistorial'
import DialogoComunicacionUpdate from '../components/DialogoComunicacionUpdate'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'

import { FORM_ADD_CARATULA } from '../../../config/forms'

function EdicionCaratulaInactiva (props) {
  const {
    id,
    registrarCaratula,
    submitActualizarCaratula,
    eliminarCaratula,
    resetCaratulaExportador
  } = props

  const [open, setOpen] = useState(false)

  const [openHistory, setOpenHistory] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    resetCaratulaExportador()
    setOpen(false)
  }

  const handleOpenHistory = () => {
    handleCloseMenu()
    setOpenHistory(true)
  }

  const handleCloseHistory = () => {
    resetCaratulaExportador()
    setOpenHistory(false)
  }

  const handleSubmit = async () => {
    submitActualizarCaratula()
  }

  const onClickRegistrarEnAduana = (id) => {
    const result = window.confirm('¿Desea REGISTRAR la Carátula en Aduana?')
    handleCloseMenu()
    if (result) registrarCaratula(id)
  }

  const onClickEliminar = (id) => {
    const result = window.confirm('¿Desea ELIMINAR la Carátula?')
    handleCloseMenu()
    if (result) eliminarCaratula(id)
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open1 = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleClickAway = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <div>
        <Dialog
          open={openHistory}
          onClose={handleCloseHistory}
          fullWidth
          maxWidth='lg'>
          <DialogoComunicacionHistorial id={id} handleClose={handleCloseHistory} />
        </Dialog>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='md'>
          <DialogoComunicacionUpdate id={id} handleClose={handleClose} handleSubmit={handleSubmit} />
        </Dialog>
        <ClickAwayListener onClickAway={() => handleClickAway()}>
          <div>
            {/* <Tooltip title={'Editar'}>
              <IconButton onClick={() => handleOpen()}>
                <EditIcon fontSize='small' />
              </IconButton>
            </Tooltip>
            <Tooltip title={'Eliminar'}>
              <IconButton onClick={() => onClickEliminar(id)}>
                <DeleteIcon fontSize='small' />
              </IconButton>
            </Tooltip>
            <Tooltip title={'Registrar en Aduana'}>
              <IconButton onClick={() => onClickRegistrarEnAduana(id)}>
                <SwapVerticalCircleIcon fontSize='small' />
              </IconButton>
            </Tooltip> */}
            {/* <Button aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>
              Acciones
            </Button> */}
            <IconButton aria-controls='fade-menu' aria-haspopup='true' onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id='fade-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open1}
              onClose={handleCloseMenu}
              TransitionComponent={Fade}
            >
              <MenuItem onClick={() => handleOpen()}><EditIcon fontSize='small' color='action' />&nbsp;Editar</MenuItem>
              <MenuItem onClick={() => onClickEliminar(id)}><DeleteIcon fontSize='small' color='error' />&nbsp;Eliminar</MenuItem>
              <MenuItem onClick={() => onClickRegistrarEnAduana(id)}><ImportExportIcon fontSize='small' color='action' />&nbsp;Registrar</MenuItem>
              <MenuItem onClick={() => handleOpenHistory()}><HistoryIcon fontSize='small' color='action' />&nbsp;Historial</MenuItem>
            </Menu>
          </div>
        </ClickAwayListener>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    openAddCaratula: state.comunicacionEmbarque.openAddCaratula
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ADD_CARATULA,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionCaratulaInactiva))
